import { genId } from "../../../utils";

const exportPreambleBlockSchema = {
  _id: genId(),
  name: 'exportPreambleBlockSchema',
  content: [
    {
      name: 'root',
      type: 'Container',
      displaySettings: {as: 'Container', className: 'schema-print-preview'},
      children: [
        {
          name: 'title',
          type: 'text',
          placeholder: 'Title',
          displaySettings : {className:'report-summary-label'}
        },
        {
          name: 'utilsContainer',
          type: 'Container',
          displaySettings: { as: 'Container' },
          children: [
            {
              name:'utilsRow',
              type: 'Container',
              displaySettings:{as:'Row'},
              children:[
                {name:'reportBlockUtilities', type: 'reportBlockUtilities'}
              ]

            },
          ]
        },
        {
          name: 'textblock1',
          type: 'text',
          placeholder: 'Text Block 1'
        },
        {
          name: 'preambleImage',
          type: 'image',
          displaySettings : {className:'report-preamble-block-image-container'},
          placeholder: 'Image',
        },
        {
          name: 'caption',
          type: 'text',
          placeholder: 'Caption'
        },
        {
          name: 'textblock2',
          type: 'text',
          placeholder: 'Text Block 2'
        }
      ]
    }
  ]
}

export {exportPreambleBlockSchema}